define('blocks/header/header',['require','exports','module','jquery','../../js/xray'],function(require, exports, module) {
    var $ = require('jquery');
    var xray = require('../../js/xray');

    var HEADER_CLASS = 'header';
    var HEADER_SCROLL_MOD = 'scroll';
    var HEADER_EL = $('.' + HEADER_CLASS);
    var PAGE_CLASS = 'page';
    var PAGE_EL = $('.' + PAGE_CLASS);

    var headerHandlerTimeout;

    $(window).on('scroll resize', function() {
        clearTimeout(headerHandlerTimeout);
        headerHandlerTimeout = setTimeout(headerHandler, 0);
    });

    function headerHandler() {
        var scrollY = window.scrollY || document.documentElement.scrollTop;

        var classNeeded = scrollY >= 130;

        HEADER_EL[(classNeeded ? 'add' : 'remove') + 'Class'](HEADER_CLASS + '_' + HEADER_SCROLL_MOD);
        PAGE_EL[(classNeeded ? 'add' : 'remove') + 'Class'](PAGE_CLASS + '_' + HEADER_SCROLL_MOD);
    }

    headerHandler();

    $(document).delegate('.js-signin-header', 'click', function() {
        xray.sendPromoXray('to', 'sing-in', 'old');
    });

    $(document).delegate('.js-signup-about', 'click', function() {
        xray.sendPromoXray('reg', '', 'old');
    });

    $(document).delegate('.js-signin-about', 'click', function() {
        xray.sendPromoXray('sign', 'in', 'old');
    });
});

